import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getWhenHire(tenant: Tenant): InfoCardProps[] {
	return [
		{
			desc: "Nemáte dostatek interních kapacit",
		},
		{
			desc: "Potřebujete nezávislý pohled odborníků",
		},
		{
			desc: "Chcete co nejrychleji dokončit projekt",
		},
		{
			desc: "Potřebujete vyřešit zapeklitý problém",
		},
		{
			desc: "Plánujete modernizovat technologie",
		},
		{
			desc: "Vašemu týmu chybí konkrétní dovednosti",
		},
	];
}
